
import { getBasePath } from './urls.js';

export function getIconRootUrl() {
    return `${getBasePath()}/icons/`;
}

export function getIconUrl(iconName) {
    return `${getIconRootUrl()}${iconName}.svg`;
}
